import { Grid } from '@kvika/theme';
import styled from 'styled-components';

export const StyledButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  font-size: ${Grid['16px']};
`;
